import { createContext, useContext, useState } from "react";
import ro from "../lang/ro";
import en from "../lang/en";

const LANGS = { ro, en };

const LangContext = createContext();

export function LangProvider({ children }) {
  const [langCode, setLangCode] = useState(
    localStorage.getItem("narratiq_lang") || "ro"
  );

  const lang = LANGS[langCode] || ro;

  const switchLang = (code) => {
    if (LANGS[code]) {
      setLangCode(code);
      localStorage.setItem("narratiq_lang", code);
    }
  };

  return (
    <LangContext.Provider value={{ lang, langCode, switchLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
